import { toast } from "react-toastify";
import { capitalize } from "@mui/material";
import Rollbar from "rollbar";

const rollbarConfig = {
  accessToken: process.env.REACT_APP_ROLLBAR_CONFIG,
  environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT,
};
const rollbar = new Rollbar(rollbarConfig);

// ========== Your existing error helpers ==========
export const IGNORED_MESSAGES = ["Unauthorized"];
export const HIDDEN_MESSAGES = ["Internal Server Error"];
export const ROLLBAR_MESSAGES = ["API name is invalid."]

export const ERROR_KEYS = {
  first_name: "First Name",
  last_name: "Last Name",
  access_type: "User Role",
};

export const getError = (data) => {
  if (!data) return;
  console.log("Handling error");
  console.log(data?.message);

  if (data?.message && ROLLBAR_MESSAGES.includes(data?.message)) {
    rollbar.error(`Message: ${data?.message}, Version: 1.12.5`);
  }

  if (data?.message && IGNORED_MESSAGES.includes(data?.message)) {
    // Not shown as a popup
  } else if (data?.message && HIDDEN_MESSAGES.includes(data?.message)) {
    toast.error("Something went wrong!");
  } else if (data?.message) {
    toast.error(capitalize(data.message));
  } else {
    Object.keys(data).forEach((key) => {
      const errorKey = ERROR_KEYS[key] ?? key;
      if (typeof data[key] === "string") {
        const error = `${capitalize(errorKey)} - ${capitalize(data[key])}`;
        toast.error(error);
      } else if (Array.isArray(data[key])) {
        const error = `${capitalize(errorKey)} - ${capitalize(
          data[key].join(", ")
        )}`;
        toast.error(error);
      }
    });
  }
};
